import { Center } from '@chakra-ui/react';
import { ReactComponent as AccessibilityIcon } from 'assets/icons/accessibility.svg';

const iconStyle = { width: '16px', height: '16px' };

export const AccessibleTemplateTag = () => {
  return (
    <Center
      w='6'
      h='6'
      borderRadius='base'
      bgColor='blackAlpha.800'
      position='absolute'
      bottom={1.5}
      right={1.5}
      data-testid='template-page-a11y-icon-tag'
    >
      <AccessibilityIcon style={iconStyle} color='white' />
    </Center>
  );
};
